<main role="main">
    <sae-navbar [links]="links"></sae-navbar>

    <sae-alerts-sidebar #sidebar></sae-alerts-sidebar>

    <div class="sae-static">
        <router-outlet></router-outlet>
    </div>
</main>